module.exports = __webpack_public_path__ + "img/edit-04.9b226db8.svg";